import { useRouter } from "@lib/i18n/navigation-app-router";
import { useLocale } from "@lib/i18n/navigation-pages-router";
import { useCurrentUser } from "@hooks/use-current-user";
import { defaultLocale } from "@lib/i18n/config";
import { useOpenCartModal, usePendingCart } from "@hooks/use-cart";
import { useOpenNavSearch } from "@hooks/use-nav-search-hooks";
import { Image, Button } from "@components/core";
import IconSvg from "@components/core/IconSvg";
import catalogContexts from "@utils/constants/catalogContexts";
import staticSitesEntryPoint from "@utils/constants/staticSitesEntryPoint";
import Navbar from "./Navbar";
import NavbarTopMenu from "./NavbarTopMenu";
import NavSearch from "./NavSearch";
import NavbarCTAHandler from "./NavbarCTAHandler";
import NavbarProfileIcon from "./NavbarProfileIcon";

function NavbarClassic({ context }) {
  const user = useCurrentUser();
  const pendingCart = usePendingCart();
  const openCartModal = useOpenCartModal();
  const router = useRouter();
  const locale = useLocale();
  const navSearchIsOpen = useOpenNavSearch();

  const logoSrc = "logo";
  const homeUrl =
    process.env.NEXT_PUBLIC_AUTONOMOUS_CUSTOMER === "false" && !user
      ? `${process.env.NEXT_PUBLIC_CUSTOMER_WEBSITE}${staticSitesEntryPoint[locale]}`
      : `${locale !== defaultLocale ? `/${locale}` : ""}/home`;
  const cartLength = pendingCart?.cart_items?.length;

  function goToMyWishlist() {
    router.push("/wishlist");
  }

  function displayTopMenuContent() {
    return [
      <div
        key="navbarclassic-searchbar"
        style={{ zIndex: 9 }}
      >
        <Button
          variant="ghost-dark"
          leftIconName="hamburger-menu"
          onClick={navSearchIsOpen}
          className="tour-guide-target-step-3"
        />
      </div>,

      <div
        className="navbar-logo"
        key="navbarclassic-logo"
      >
        <a href={homeUrl}>
          <Image
            className="logo-full"
            src={logoSrc}
            style={{ height: "24px" }}
            alt="logo"
          />
          <Image
            className="logo-small"
            src="logoSmall"
            style={{ height: "24px" }}
            alt="logo"
          />
        </a>
      </div>,

      <div
        className="navbar-right gap-3"
        key="navbarclassic-carticon"
      >
        {((context === catalogContexts.sales && user) || cartLength > 0) && (
          <div
            className="navbar-cart-container"
            style={{ zIndex: 9 }}
          >
            <button
              type="button"
              className="btn-transparent position-relative cursor-pointer cart-icon"
              onClick={openCartModal}
            >
              <IconSvg
                name="cart"
                className="cart-icon-picture"
              />
              {cartLength > 0 && (
                <span className="cart-icon-counter font-size-xs">{cartLength}</span>
              )}
            </button>
          </div>
        )}

        <div style={{ zIndex: 9 }}>
          <NavbarProfileIcon />
        </div>

        {user?.state === "subscriber" && (
          <div
            className="navbar-wishlist-container"
            style={{ zIndex: 9 }}
          >
            <div className="heart-icon-btn-container">
              <button
                type="button"
                className="btn-transparent position-relative cursor-pointer tour-guide-target-step-2"
                onClick={goToMyWishlist}
              >
                <IconSvg
                  name="heart-empty"
                  className="heart-icon"
                />
              </button>
            </div>
          </div>
        )}

        {context !== catalogContexts.sales && (
          <div style={{ zIndex: 9 }}>
            <NavbarCTAHandler />
          </div>
        )}
      </div>,
    ];
  }

  return (
    <Navbar>
      <NavbarTopMenu>{displayTopMenuContent()}</NavbarTopMenu>
      <NavSearch
        logoSrc={logoSrc}
        homeUrl={homeUrl}
      />
    </Navbar>
  );
}

export default NavbarClassic;
